<template>
  <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Регистрация</h2>
    </div>

    <div class="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">
      <form v-if="!registered" class="space-y-6" action="#" method="POST" @submit.prevent="submitForm(e)">
        <div class="mb-4">
          <!-- Контейнер для табов -->
          <div class="flex space-x-1 rounded-lg bg-gray-100 p-1">
            <!-- Таб Физ. лицо -->
            <div class="flex-1">
              <input type="radio"
                     name="form"
                     id="formFiz"
                     value="Fiz"
                     class="peer sr-only"
                     v-model="formData.form"
                     :checked="formData.form === 'Fiz'"
                     @change="formData.form = 'Fiz'"/>
              <label
                for="formFiz"
                class="flex cursor-pointer items-center justify-center rounded-md py-2 px-3 text-sm font-medium transition-all duration-200 peer-checked:bg-white peer-checked:shadow-sm peer-checked:text-gray-900 peer-checked:ring-1 peer-checked:ring-gray-300 peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-600 hover:bg-gray-50 hover:text-gray-900 text-gray-700">
              Физ. лицо
            </label>
            </div>

            <!-- Таб Юр. лицо -->
            <div class="flex-1">
              <input type="radio"
                     name="form"
                     id="formUr"
                     value="Fiz"
                     class="peer sr-only"
                     v-model="formData.form"
                     :checked="formData.form === 'Ur'"
                     @change="formData.form = 'Ur'"/>
              <label
                  for="formUr"
                  class="flex cursor-pointer items-center justify-center rounded-md py-2 px-3 text-sm font-medium transition-all duration-200 peer-checked:bg-white peer-checked:shadow-sm peer-checked:text-gray-900 peer-checked:ring-1 peer-checked:ring-gray-300 peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-600 hover:bg-gray-50 hover:text-gray-900 text-gray-700">
                Юр. лицо
              </label>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="flex items-center justify-between">
            <label for="email" class="block text-sm/6 font-medium text-gray-900">Логин</label>
          </div>
          <div class="mt-1">
            <input type="text" name="login" id="login" required="true" v-model="formData.login" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
          </div>
        </div>

        <div class="mb-4">
          <div class="flex items-center justify-between">
            <label for="email" class="block text-sm/6 font-medium text-gray-900">Email</label>
            <div class="text-sm"></div>
          </div>
          <div class="mt-1">
            <input type="email" name="email" id="email"  required="" v-model="formData.email" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
          </div>
        </div>

        <div class="mb-4">
          <div class="flex items-center justify-between">
            <label for="password" class="block text-sm/6 font-medium text-gray-900">Пароль</label>
            <div class="text-sm"></div>
          </div>
          <div class="mt-1">
            <input type="password" name="password" id="password" autocomplete="" v-model="formData.password" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between">
            <label for="password_confirm" class="block text-sm/6 font-medium text-gray-900">Повторите пароль</label>
            <div class="text-sm"></div>
          </div>
          <div class="mt-1">
            <input type="password" name="password_confirm" id="password_confirm" v-model="formData.passwordConfirm" autocomplete="" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
          </div>
        </div>

        <div>
          <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Зарегистрироваться</button>
        </div>

        <div v-if="errors !== null" class="text-red-800 clear-left text-left">
          <div v-if="typeof errors == 'string'">
            {{errors}}
          </div>
          <div v-if="typeof errors == 'object'">
            <span v-for="(err, code) in errors" v-bind:key="err">
              {{code}}:<br>
              <span class="block" v-if="typeof err == 'string'">{{err}}</span>
              <span v-if="typeof err == 'object'">
                <span class="block" v-for="(e, i) in err" v-bind:key="i">{{e}}</span>
              </span>
            </span><br><br>
          </div>
        </div>
      </form>
      <div v-else>
        <h2>Вы успешно зарегистрированы</h2>
        <br>
      </div>

      <p class="mt-10 text-center text-sm/6 text-gray-500">
        <router-link :to="{ name: 'home' }" class="font-semibold text-indigo-600 hover:text-indigo-500">
          ← Форма авторизации
        </router-link>
      </p>
    </div>
  </div>
</template>
<script>
import store from '@/store.js'

export default {
  name: 'AuthRegistrationPage',
  data() {
    return {
      store,
      registered: false,
      sending: false,
      errors: null,
      formData: {
        form: "Fiz",
        login: null,
        email: null,
        password: null,
        passwordConfirm: null,
      }
    }
  },
  methods: {
    submitForm: function () {
      this.errors = null;
      if (this.sending) {
        console.log("sending, return")
        return;
      }

      if (this.formData.password !== this.formData.passwordConfirm) {
        this.errors = "Пароли не совпадают";
        return;
      }

      this.$yandexMetrika.reachGoal("from-registration-submit")

      console.log("submit")
      let c = this;

      this.sending = true
      this.axios.post('/api/registration', this.formData).then(function() {
        // console.log(response.data);
        //c.$router.push({ path: 'login' })
        c.registered = true
        c.sending = false
      }).catch(function(err) {
        c.sending = false
        //console.log('ERROR', err);
        if (err.status === 422) {
          c.errors = err.response.data.error;
          return;
        }

        c.errors = "Ошибка";
      });
    }
  }
}

</script>